import { z } from 'zod'
import type { TransactionCategory, PaymentMethod } from '@/types'

export const CATEGORY_OPTIONS: TransactionCategory[] = [
  'PATIENT_FEE',
  'SALARY',
  'UTILITIES',
  'SUPPLIES',
  'MAINTENANCE',
  'GOVERNMENT_FUNDING',
  'OTHER',
]

export const PAYMENT_METHOD_OPTIONS: PaymentMethod[] = ['CASH', 'BANK_TRANSFER', 'CARD', 'OTHER']

export const addTransactionSchema = z.object({
  transactionType: z.enum(['INCOME', 'EXPENSE'], {
    message: 'financials:form.errors.typeRequired',
  }),
  amount: z
    .string()
    .min(1, 'financials:form.errors.amountRequired')
    .refine((val) => !isNaN(Number(val)) && Number(val) > 0, {
      message: 'financials:form.errors.amountPositive',
    }),
  category: z.enum(
    [
      'PATIENT_FEE',
      'SALARY',
      'UTILITIES',
      'SUPPLIES',
      'MAINTENANCE',
      'GOVERNMENT_FUNDING',
      'OTHER',
    ],
    { message: 'financials:form.errors.categoryRequired' }
  ),
  description: z.string().min(1, 'financials:form.errors.descriptionRequired').max(500),
  transactionDate: z.string().min(1, 'financials:form.errors.dateRequired'),
  patientId: z.string().optional().or(z.literal('')),
  paymentMethod: z.enum(['CASH', 'BANK_TRANSFER', 'CARD', 'OTHER']),
  referenceNumber: z.string().optional().or(z.literal('')),
})

export type AddTransactionFormValues = z.infer<typeof addTransactionSchema>

export function getDefaultValues(patientId?: string): AddTransactionFormValues {
  return {
    transactionType: 'INCOME',
    amount: '',
    category: patientId ? 'PATIENT_FEE' : 'OTHER',
    description: '',
    transactionDate: new Date().toISOString().split('T')[0],
    patientId: patientId ?? '',
    paymentMethod: 'CASH',
    referenceNumber: '',
  }
}
